import React from 'react';
import '../style_new.css';

const Loader = () => {
  return <div class="loader-wrapper">
            <div class="loader"></div>
          </div>
};

export default Loader;